/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { useSelector } from 'react-redux';
import AddFlight from './AddFlight';
import BookedFlights from './BookedFlights/BookedFlights';

function Body() {
  const flights = useSelector(state => state.flights);
  return (
    <section>
      {/* <!-- Input Data --> */}
      <AddFlight />

      {/* <!-- Preview Data --> */}
      {flights?.length !== 0 && <BookedFlights />}
    </section>
  );
}

export default Body;
